(function () {
  'use strict';

  // ── CSS ───────────────────────────────────────────────────────────────────
  var style = document.createElement('style');
  style.textContent = '' +
    '.lc-atc-btn-wrap{width:100%;}' +
    /* card counter: ghost pill — replaces the ATC button */
    '.lc-card-counter{' +
    '  display:none;' +
    '  align-items:center;width:100%;' +
    '  background:rgb(var(--color-button));' +
    '  border-radius:100px;min-height:34px;' +
    '}' +
    /* PDP counter row */
    '#lc-pdp-counter{' +
    '  display:none;' +
    '  align-items:center;gap:10px;' +
    '  margin-top:10px;padding:6px 6px 6px 14px;' +
    '  background:rgba(var(--color-foreground),.05);' +
    '  border:1px solid rgba(var(--color-foreground),.12);' +
    '  border-radius:100px;' +
    '}' +
    '.lc-pdp-counter-label{font-size:12px;font-weight:500;flex:1;color:rgba(var(--color-foreground),.75);letter-spacing:.01em;}' +
    /* PDP inner controls: solid pill */
    '.lc-pdp-counter-controls{' +
    '  display:flex;align-items:center;' +
    '  background:rgb(var(--color-button));' +
    '  border-radius:100px;' +
    '}' +
    /* shared counter buttons */
    '.lc-counter-btn{' +
    '  background:none;border:none;cursor:pointer;line-height:1;' +
    '  color:rgb(var(--color-button-text));' +
    '  font-size:18px;font-weight:400;' +
    '  display:flex;align-items:center;justify-content:center;' +
    '  padding:0 12px;flex-shrink:0;min-height:34px;' +
    '  transition:opacity .15s;' +
    '}' +
    '.lc-counter-btn:hover:not(:disabled){opacity:.65;}' +
    '.lc-counter-btn:disabled{opacity:.3;cursor:not-allowed;}' +
    '.lc-pdp-counter-controls .lc-counter-btn{font-size:17px;padding:5px 12px;min-height:34px;}' +
    /* shared qty number */
    '.lc-counter-qty{' +
    '  font-size:14px;font-weight:700;' +
    '  color:rgb(var(--color-button-text));' +
    '  flex:1;display:flex;align-items:center;justify-content:center;' +
    '  min-width:22px;' +
    '}' +
    '.lc-pdp-counter-controls .lc-counter-qty{font-size:14px;min-width:26px;padding:5px 1px;}' +
    /* shake when add fails (inventory limit) */
    '@keyframes lc-shake{0%,100%{transform:translateX(0)}20%{transform:translateX(-5px)}40%{transform:translateX(5px)}60%{transform:translateX(-4px)}80%{transform:translateX(4px)}}' +
    '.lc-counter-shake{animation:lc-shake .35s ease;}' +
    /* toast */
    '#lc-toast{' +
    '  position:fixed;bottom:80px;left:50%;' +
    '  transform:translateX(-50%) translateY(16px);' +
    '  display:flex;align-items:center;gap:8px;' +
    '  background:#14532d;color:#fff;' +
    '  padding:11px 22px;border-radius:100px;' +
    '  font-size:14px;font-weight:600;' +
    '  box-shadow:0 4px 24px rgba(0,0,0,.22);' +
    '  z-index:99999;pointer-events:none;' +
    '  opacity:0;transition:opacity .22s,transform .22s;' +
    '  max-width:90vw;white-space:nowrap;' +
    '}';
  document.head.appendChild(style);

  // ── 1. Suppress cart-drawer auto-open ─────────────────────────────────────
  function patchCartDrawer() {
    if (window.__lcDrawerPatched) return;
    var Ctor = customElements.get('cart-drawer');
    if (!Ctor || !Ctor.prototype || !Ctor.prototype.show) return;
    var orig = Ctor.prototype.show;
    Ctor.prototype.show = function () {
      if (window.__lcSuppressCartOpen) {
        window.__lcSuppressCartOpen = false;
        return;
      }
      return orig.apply(this, arguments);
    };
    window.__lcDrawerPatched = true;
  }
  if (typeof customElements !== 'undefined' && customElements.whenDefined) {
    customElements.whenDefined('cart-drawer').then(patchCartDrawer);
  }

  // ── 2. Toast ───────────────────────────────────────────────────────────────
  function showToast(msg) {
    var prev = document.getElementById('lc-toast');
    if (prev) prev.remove();
    var el = document.createElement('div');
    el.id = 'lc-toast';
    el.innerHTML = '<span>✓</span><span>' + (msg || 'Producto agregado') + '</span>';
    document.body.appendChild(el);
    requestAnimationFrame(function () {
      el.style.opacity = '1';
      el.style.transform = 'translateX(-50%) translateY(0)';
    });
    setTimeout(function () {
      el.style.opacity = '0';
      el.style.transform = 'translateX(-50%) translateY(8px)';
      setTimeout(function () { if (el.parentNode) el.remove(); }, 280);
    }, 2800);
  }

  // ── 3. Cart state ──────────────────────────────────────────────────────────
  var cartState = {};
  var cartLines = {};
  var capturedCart = null; // cart object captured from theme's cartUpdate event

  function applyCart(cart) {
    cartState = {};
    cartLines = {};
    (cart.items || []).forEach(function (item, idx) {
      var k = String(item.variant_id);
      cartState[k] = (cartState[k] || 0) + item.quantity;
      if (!cartLines[k]) cartLines[k] = idx + 1;
    });
  }

  function fetchCartState(cb) {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (c) { applyCart(c); if (cb) cb(); })
      .catch(function () { if (cb) cb(); });
  }

  // ── 4. Render counters ─────────────────────────────────────────────────────
  function updateAllCounters() {
    // Card counters: swap button ↔ counter depending on qty
    document.querySelectorAll('.lc-card-counter').forEach(function (counter) {
      var vid = counter.getAttribute('data-variant-id');
      var qty = cartState[String(vid)] || 0;
      counter.querySelector('.lc-counter-qty').textContent = qty;
      // The ATC button is a sibling inside .lc-atc-btn-wrap
      var wrap = counter.parentElement;
      var atcBtn = wrap ? wrap.querySelector('.product-card__atc') : null;
      if (qty > 0) {
        counter.style.display = 'flex';
        if (atcBtn) atcBtn.style.display = 'none';
      } else {
        counter.style.display = 'none';
        if (atcBtn) atcBtn.style.display = '';
      }
    });
    updatePdpCounter();
  }

  // ── 5. PDP counter & variant tracking ─────────────────────────────────────
  var pdpVid = null;

  function getPdpVariantId() {
    var inp = document.querySelector('form[is="product-form"] .product-variant-id');
    return inp ? inp.value : null;
  }

  function updatePdpCounter() {
    var counter = document.getElementById('lc-pdp-counter');
    if (!counter) return;
    var vid = pdpVid || getPdpVariantId();
    if (!vid) { counter.style.display = 'none'; return; }
    counter.setAttribute('data-variant-id', vid);
    var qty = cartState[String(vid)] || 0;
    counter.querySelector('.lc-counter-qty').textContent = qty;
    counter.style.display = qty > 0 ? 'flex' : 'none';
  }

  function startVariantTracking() {
    if (!document.getElementById('lc-pdp-counter')) return;
    var last = null;
    setInterval(function () {
      var vid = getPdpVariantId();
      if (vid && vid !== last) {
        last = vid;
        pdpVid = vid;
        updatePdpCounter();
      }
    }, 500);
  }

  // ── 6. Counter click handlers ──────────────────────────────────────────────

  // Collect section IDs the theme registered (same mechanism theme uses internally)
  function getSections() {
    var sections = [];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sections } })
    );
    return sections;
  }

  // Apply a cart response, update counters, notify theme, re-enable button
  function applyCartAndNotify(btn, cart) {
    applyCart(cart);
    updateAllCounters();
    try {
      if (window.FoxTheme && window.FoxTheme.pubsub && window.FoxTheme.pubsub.PUB_SUB_EVENTS) {
        window.FoxTheme.pubsub.publish(
          window.FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate,
          { cart: cart }
        );
      }
    } catch (_) {}
    btn.disabled = false;
  }

  // After a cart change: /cart/change.js response IS the full cart — use it directly.
  // Only falls back to /cart.js if response is an error (missing items array).
  function afterCartChange(btn, parsed) {
    if (parsed && parsed.items) {
      applyCartAndNotify(btn, parsed);
    } else {
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) { applyCartAndNotify(btn, cart); })
        .catch(function () {})
        .then(function () { btn.disabled = false; });
    }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.lc-counter-btn');
    if (!btn) return;
    e.preventDefault();

    var counter = btn.closest('.lc-card-counter') || btn.closest('#lc-pdp-counter');
    if (!counter) return;
    var vid = counter.getAttribute('data-variant-id');
    if ((!vid || vid === '') && counter.id === 'lc-pdp-counter') vid = getPdpVariantId();
    if (!vid) return;

    var isPlus = btn.classList.contains('lc-counter-plus');
    var current = cartState[String(vid)] || 0;

    // Optimistic UI: update counter instantly before the request completes
    var optimistic = isPlus ? current + 1 : Math.max(0, current - 1);
    cartState[String(vid)] = optimistic;
    updateAllCounters();
    btn.disabled = true;

    var sections = getSections();

    if (isPlus) {
      var plusLine = cartLines[String(vid)];
      var plusBody = plusLine
        ? { line: plusLine, quantity: current + 1, sections: sections, sections_url: window.location.pathname }
        : { id: Number(vid), quantity: current + 1, sections: sections, sections_url: window.location.pathname };
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(plusBody),
      })
        .then(function (r) { return r.json(); })
        .then(function (parsed) {
          if (parsed.status) {
            // Revert optimistic update and shake
            cartState[String(vid)] = current;
            updateAllCounters();
            var el = counter;
            el.classList.remove('lc-counter-shake');
            void el.offsetWidth;
            el.classList.add('lc-counter-shake');
            el.addEventListener('animationend', function () {
              el.classList.remove('lc-counter-shake');
            }, { once: true });
          }
          afterCartChange(btn, parsed);
        })
        .catch(function () { btn.disabled = false; });
    } else {
      var lineIdx = cartLines[String(vid)];
      var body = {
        quantity: Math.max(0, current - 1),
        sections: sections,
        sections_url: window.location.pathname,
      };
      if (lineIdx) {
        body.line = lineIdx;
      } else {
        body.id = Number(vid);
      }
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
      })
        .then(function (r) { return r.json(); })
        .then(function (parsed) { afterCartChange(btn, parsed); })
        .catch(function () { btn.disabled = false; });
    }
  });

  // ── 7. Event wiring ────────────────────────────────────────────────────────
  document.addEventListener('product-ajax:added', function (e) {
    window.__lcSuppressCartOpen = true;
    var title = null;
    try {
      var p = e.detail.product;
      title = p.product_title || (p.items && p.items[0] && p.items[0].product_title) || p.title || null;
    } catch (_) {}
    showToast(title ? (title + ' agregado') : 'Producto agregado al carrito');
    if (capturedCart) {
      applyCart(capturedCart);
      updateAllCounters();
      capturedCart = null;
    } else {
      fetchCartState(updateAllCounters);
    }
  });

  document.addEventListener('cart:refresh', function () {
    setTimeout(function () { fetchCartState(updateAllCounters); }, 200);
  });

  function init() {
    patchCartDrawer();
    fetchCartState(function () {
      updateAllCounters();
      startVariantTracking();
    });
    try {
      if (window.FoxTheme && window.FoxTheme.pubsub && window.FoxTheme.pubsub.PUB_SUB_EVENTS) {
        window.FoxTheme.pubsub.subscribe(
          window.FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate,
          function (event) {
            if (event && event.cart && event.cart.items) capturedCart = event.cart;
          }
        );
      }
    } catch (_) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
